<template>
  <PageFrame v-if="slides[0]" :embedded="true" :theme="themeData" :options="slides[0].options" :direction="direction">
    <div class="slide-preview-container container" data-cy="slide-preview-container">
      <div class="inner-container">
        <div v-if="prevSlideIndex" @click.stop="previousStep()" class="direction prev" data-cy="slide-preview-direction-prev">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <title>interface-arrows-button-left</title>
            <path class="a" d="M10.146.5,4,6.646a.5.5,0,0,0,0,.708L10.146,13.5" />
          </svg>
        </div>
        <SlideContainer
          v-for="(slide, key) in slides"
          :active="isActive(key)"
          :key="slide.id"
          :slide="slide"
          :moderatorView="true"
          :step="step"
          :theme="themeData"
          :event="event"
          :recap="true"
          :metaData="metaData"
          :avatarPreviews="true"
          :eventSettings="eventSettings"
          :forceShowJoinSlideLogo="true"
          :data-cy="`preview-slide-id-${key}`"
        />
        <div v-if="nextSlideIndex <= slides.length" @click.stop="nextStep()" class="direction next" data-cy="slide-preview-direction-next">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <title>interface-arrows-button-right</title>
            <path class="a" d="M3.854.5,10,6.646a.5.5,0,0,1,0,.708L3.854,13.5" />
          </svg>
        </div>
      </div>
    </div>
  </PageFrame>
</template>

<script>
import SlideContainer from '~/components/SlideContainer'
import Slideshow from '~/components/mixins/Slideshow'
import PageFrame from '~/components/PageFrame'

export default {
  name: 'SlideshowComponent',
  components: { PageFrame, SlideContainer },
  mixins: [Slideshow],
  props: {
    themeData: {
      type: Object,
      required: true
    },
    metaData: {
      type: Object,
      required: true
    },
    eventSettings: {
      type: Object,
      required: true
    },
    deckSlides: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      event: {}
    }
  },
  computed: {
    slideDeck () {
      return {
        slides: this.deckSlides
      }
    }
  },
  mounted () {
    // Clean up previous values in the store
    // SEE /components/mixins/SlideControls.vue@setSteps()
    this.$store.commit('setSteps', [{ name: 'defaultStep' }])
    this.mountSlideshow()
    window.addEventListener('keydown', this.checkHandleKeydown)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.checkHandleKeydown)
  },
  methods: {
    checkHandleKeydown (evt) {
      if (!['INPUT'].includes(evt.target.tagName)) {
        this.handleKeydown(evt)
      }
    }
  }
}
</script>

<style scoped lang="scss">
$slide-show-border-radius: 7px;

:deep(.page-frame) {
  padding: 0;
  background: none
}

.slide-preview-container {
  margin: 0 auto;
  height: 50vw;
  max-height: 400px;
  position: relative;
  user-select: none;
  background-color: white;
  border: none;
  border-radius: $slide-show-border-radius;

  @media screen and (max-width: 1040px) {
    height: 50vw;
  }

  @media screen and (max-width: 1000px) {
    height: 55vw;
  }

  @media screen and (max-width: 800px) {
    height: 65vw;
  }

  .inner-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: $slide-show-border-radius;
    background-color: white;
    overflow: hidden;
  }

  .hero.is-slide {
    border-radius: $slide-show-border-radius;
    overflow: hidden;
    box-shadow: none;
  }

  :deep(.is-free) .slide-branding,
  :deep(.is-free) .slide-branding:hover,
  :deep(.slide-branding),
  :deep(.slide-branding):hover {
    svg, img {
      opacity: 1;
    }
  }

  :deep(.slide-branding.user-brand) {
    width: min(5em, 180px);
    max-width: min(5em, 180px);
    height: min(3.5em, 120px);
  }
}
</style>
